<h2 mat-dialog-title>Update product availability</h2>
<mat-dialog-content class="mat-typography">
  <ul>
    @for (restriction of data; track restriction) {
      <li>
        <span>{{ restriction.label }}: </span>
        @if (restriction.value) {
          <b class="green">ACTIVATE</b>
        }
        @if (!restriction.value) {
          <b class="red">DISABLE</b>
        }
      </li>
    }
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
